var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('asc-container',{staticClass:"asc-user-profile-template"},[_c('asc-user-profile-info',{attrs:{"user-profile":_vm.userProfile}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }